import Autosuggest from '../../organisms/search/helpers/Autosuggest';

class SearchCta {
  constructor(params) {
    this.form = params.form;
    this.input = params.input || this.form?.querySelector('.search-cta-input');
    this.clearButton =
      params.clearButton || this.form?.querySelector('.search-cta-input-clear');
    this.submitButton =
      params.submitButton ||
      this.form?.querySelector('.search-cta-submit-button');
  }

  init() {
    if (!this.form) return;
    this.bindEvents();
    this.clearButtonVisibilityHandler();
    this.initAutosuggest();
  }

  destroy() {
    this.unbindEvents();
    this.clearButton?.classList.remove('search-cta-input-clear-visible');
  }

  bindEvents() {
    this.submitButton?.addEventListener('click', this.submit.bind(this));
    this.submitButton?.addEventListener('keyup', this.submit.bind(this));
    this.clearButton?.addEventListener('click', this.clear.bind(this));

    if (this.clearButton && this.input)
      this.input.addEventListener(
        'input',
        this.clearButtonVisibilityHandler.bind(this)
      );
  }

  unbindEvents() {
    this.submitButton?.removeEventListener('click', this.submit);
    this.submitButton?.removeEventListener('keyup', this.submit);
    this.clearButton?.removeEventListener('click', this.clear);
    this.input?.removeEventListener('input', this.clearButtonVisibilityHandler);
  }

  submit(e) {
    if (e) e.preventDefault();
    if (e.key && e.key !== 'Enter') return;

    const baseUrl = window.location.origin;
    const searchUrl = this.form.getAttribute('data-url-format');
    const inputValue = this.input.value;
    const searchURL =
      baseUrl +
      searchUrl +
      (inputValue ? '#tx_solr%5Bq%5D=' : '') +
      encodeURIComponent(inputValue);
    window.location.href = searchURL;
    const isSearchPage = document.querySelector(
      '#search-app[data-main-search="true"]'
    );
    if (isSearchPage) {
      window.location.reload();
    }
  }

  clear() {
    this.input.value = '';
    this.input.focus();
    this.clearButtonVisibilityHandler();
  }

  clearButtonVisibilityHandler() {
    if (!this.clearButton) return;

    if (this.input.value !== '') {
      this.clearButton.classList.add('search-cta-input-clear-visible');
      return;
    }

    this.clearButton.classList.remove('search-cta-input-clear-visible');
  }

  initAutosuggest() {
    setTimeout(() => {
      if (this.form && this.input) {
        const autoSuggestObj = new Autosuggest({
          // input which triggers solr
          input: this.input,
          // form element which contains the input
          form: this.form,
          // [optional] min length of text until we fire the ajax-request (0 is default)
          textMinLength: 2,
          // [optional] set true, if you want to enable typeahead
          typeahead: false,
          // [optional] prevent AutoSuggest from submitting the form (e.g. if you want to trigger ajax instead) (default is false)
          preventSubmit: true,
          // [optional] allow empty submit even if input is empty (default is false)
          allowEmptySubmit: true,
          // [optional] submit form if user clicks on a suggestion button (default is false)
          submitOnSuggestionClick: false,
          onSelecting: () => this.clearButtonVisibilityHandler(),
        });
        autoSuggestObj.init();
      }
    }, 0);
  }
}

const searchCtaForm = document.querySelectorAll('.search-cta-form');
const searchCtaInstances = [];

searchCtaForm.forEach(form => {
  const searchCtaInstance = new SearchCta({
    form,
  });

  searchCtaInstance.init();
  searchCtaInstances.push(searchCtaInstance);
});
